var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.5H2.25C1.425 4.5 0.75 5.175 0.75 6V12C0.75 12.825 1.425 13.5 2.25 13.5H15.75C16.575 13.5 17.25 12.825 17.25 12V6C17.25 5.175 16.575 4.5 15.75 4.5ZM15.75 12H2.25V6H3.75V9H5.25V6H6.75V9H8.25V6H9.75V9H11.25V6H12.75V9H14.25V6H15.75V12Z",
    fill: "#182E45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.4664e06c13cf2c0c97f44583f7fd37c1.svg";
export { ForwardRef as ReactComponent };